import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { DisplayNameControlKeys } from './types';

interface DisplayNameStore {
  displayNamePref: DisplayNameControlKeys;
  setDisplayNamePref: (pref: DisplayNameControlKeys) => void;
}

export const useGetDisplayNameStore = create<DisplayNameStore>()(
  subscribeWithSelector((set) => ({
    displayNamePref: DisplayNameControlKeys.LEGAL_NAME,
    setDisplayNamePref: (pref) => set({ displayNamePref: pref }),
  }))
);
